import React from 'react';
import { TopBadge } from './components/TopBadge';
import { Hero } from './components/Hero';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { MegapackIntro } from './components/MegapackIntro';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingBlock } from './components/PricingBlock';
import { EliteBreakdown } from './components/EliteBreakdown';
import { LongTestimonials } from './components/LongTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBadge data-id="element-2" />
      <Hero data-id="element-3" />
      <QuickTestimonials data-id="element-4" />
      <Problems data-id="element-5" />
      <MegapackIntro data-id="element-6" />
      <TomosSection data-id="element-7" />
      <BonosSection data-id="element-8" />

      {/* First CTA Block */}
      <div className="bg-gray-50 pt-6 md:pt-10" data-id="element-9">
        <div className="text-center mb-4 md:mb-8 px-4" data-id="element-10">
          <h2 className="text-2xl md:text-4xl font-black text-brand-900" data-id="element-11">
            No dejes pasar esta oportunidad
          </h2>
        </div>
        <UrgencyBlock data-id="element-12" />
        <PricingBlock sectionId="pricing" data-id="element-13" />
      </div>

      <EliteBreakdown data-id="element-14" />
      <LongTestimonials data-id="element-15" />
      <Guarantee data-id="element-16" />
      <FAQ data-id="element-17" />
      <CostComparison data-id="element-18" />

      {/* Final CTA Block */}
      <div className="bg-gray-50 pt-10 pb-6 md:pt-16 md:pb-10 border-t border-gray-200" data-id="element-19">
        <div className="text-center mb-4 md:mb-8 px-4" data-id="element-20">
          <h2 className="text-2xl md:text-4xl font-black text-brand-900" data-id="element-21">
            Tu carrera organizada empieza hoy
          </h2>
        </div>
        <UrgencyBlock data-id="element-22" />
        <PricingBlock data-id="element-23" />
      </div>

      <Footer data-id="element-24" />
      <StickyMobileCTA data-id="element-25" />
      <PurchasePopup data-id="element-26" />
    </div>;
}